import { useContext, useState } from "react";
import "./NameForm.scss";
import { simplyClick, validateName } from "../../helpers";
import ButtonSubmit from "../ButtonSubmit";
import InputGlobal from "../InputGlobal";
import { errorEventsName } from "../../constants";
import { ContextProfileUser } from "../../lib/profileContext";
import Tooltip from "../Tooltip";
import ProgressDots from "../ProgressDots/ProgressDots";
import cn from "classnames";

const NameForm = ({ nextStep }) => {
  const [errorName, setErrorName] = useState(null);
  const { data, setData } = useContext(ContextProfileUser);
  const [showTooltip, setShowTooltip] = useState(false);

  const handlerSubmit = (e) => {
    e.preventDefault();

    const { status, error = { text: "", type: "" } } = validateName(
      data?.first_name ?? ""
    );

    if (error.type) {
      simplyClick(errorEventsName[error.type]);
    }

    if (!status) {
      setErrorName(error.text);
    } else {
      simplyClick("cl_lnd_name_st3_action", { text: "next" });
      nextStep();
    }
  };

  const handleAddName = ({ target: { value } }) => {
    setErrorName(null);
    setShowTooltip(false);
    setData({ ...data, first_name: value });
  };

  return (
    <div className="name__form-wrapper">
      <div className="user__form-top">
        <h3>My name</h3>
      </div>
      <form className="form__name" onSubmit={handlerSubmit} autoComplete="on">
        <p className="name__text">
          Share your name or nickname. Change it later if you want.
        </p>
        <div className="input__name-wrap">
          <InputGlobal
            onChange={(e) => handleAddName(e)}
            value={data?.first_name || ""}
            placeholder={"Enter your name or nickname"}
            className={cn("input__global", "input__name", {
              input__error: errorName,
            })}
            name={"name"}
            type={"name"}
            autoComplete={"name"}
            onFocus={() => {
              if (!data.first_name || data.first_name.trim() === "") {
                setShowTooltip(true);
              } else {
                setShowTooltip(false);
              }
              simplyClick("cl_lnd_name_st3_type_name", { text: "type_name" });
            }}
            onBlur={() => setShowTooltip(false)}
          />
          {errorName && <p className="errorName">{errorName}</p>}
          <Tooltip
            text="Your name must include at least 2 English letters. No numbers or special characters are allowed."
            showTooltip={showTooltip}
            className="name"
          />
        </div>

        <ButtonSubmit className={"button__global button__name"} text={"NEXT"} />
        <ProgressDots total={12} activeCount={3} />
      </form>
    </div>
  );
};

export default NameForm;
